import * as React from "react";
import { useMutation, Types } from "@grandvisionhq/graphql";
import { useIntl } from "@grandvisionhq/state";
import { useWishlistId } from "@grandvisionhq/svc-wishlist";
import ADD_TO_SHOPPING_LIST from "../../operations/mutations/operations/mutations/add-to-shopping-list.js";
const useAddToShoppingList = ({
  isLoggedIn,
  onError,
  onCompleted
}) => {
  const { locale } = useIntl();
  const [hasError, setHasError] = React.useState(false);
  const { updateWishlist } = useWishlistId();
  const currentSkus = React.useRef([]);
  const [mutation, { data, loading, error }] = useMutation(
    ADD_TO_SHOPPING_LIST,
    {
      onError() {
        onError?.(currentSkus.current);
      },
      context: {
        forwardHeaders: {
          "Accept-Language": locale
        }
      }
    }
  );
  const handleOnCompleted = React.useCallback(
    (data2) => {
      if (data2.addToShoppinglist.__typename === "AddToShoppinglistFailureResponse") {
        onError?.(currentSkus.current);
      } else {
        if (data2?.addToShoppinglist.__typename === "AddToShoppinglistSuccessResponse") {
          updateWishlist(!isLoggedIn ? { id: data2.addToShoppinglist.result.id } : void 0);
        }
      }
      onCompleted?.(data2);
    },
    [onCompleted, onError, isLoggedIn, updateWishlist, currentSkus]
  );
  const addToShoppinglist = React.useCallback(
    async (productSkus, wishlistId) => {
      try {
        currentSkus.current = productSkus;
        const { data: data2 } = await mutation({
          variables: {
            input: {
              productSkus,
              shoppinglistId: wishlistId ?? null,
              shoppinglistType: Types.ShoppinglistType.WISHLIST
            }
          }
        });
        if (data2) {
          handleOnCompleted(data2);
          return Promise.resolve(data2);
        }
      } catch (e) {
        setHasError(true);
        console.error("Error while adding a wishlist item to the shopping list", e);
      }
      return Promise.reject();
    },
    [handleOnCompleted, mutation]
  );
  return {
    addToShoppinglist,
    loading,
    error: error ?? hasError ?? data?.addToShoppinglist.__typename === "AddToShoppinglistFailureResponse" ?? null
  };
};
export {
  useAddToShoppingList
};
//# sourceMappingURL=use-add-to-shopping-list.js.map
